export const DELIVERY_TYPE_FROM_USER = 2;
export const DELIVERY_TYPE_TO_USER_AND_RETURN = 3;

export const STATUS_PRE_TRANSIT = 'PRE_TRANSIT';
export const STATUS_TRANSIT = 'TRANSIT';
export const STATUS_DELIVERED = 'DELIVERED';
export const STATUS_RETURNED = 'RETURNED';
export const STATUS_FAILURE = 'FAILURE';
